import React, { useEffect } from 'react'
import { copyright, copyrightParams, errorContent } from '../../../constants/copyright'
import { safeHTML } from '../../../utils/safeHTML'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import useOnlineStatus from '../../../hooks/useOnlineStatus'
import useStateControls from '../../../hooks/useStateControls'
import { useTranslation } from '../../../translations'
import { RELOAD_REASONS, reloadApplication } from '../../features/errorBoundary/ErrorBoundary'
import { PRELOADER } from '../../../constants/shared/states/names'

const { title, text, button } = errorContent

const Error = React.forwardRef(function (_, ref) {
  const isOnline = useOnlineStatus()

  const { t } = useTranslation()
  const { setState } = useStateControls()

  useEffect(() => {
    if (isOnline) setState(PRELOADER)
  }, [isOnline])

  return (
    <section
      className={'error'}
      ref={ref}
    >
      <div className={'error__content'}>
        <h2 className={'error__title'}>{safeHTML(t(title))}</h2>
        <p className={'error__text'}>{safeHTML(t(text))}</p>
        <CustomButton
          {...button}
          onClick={() => reloadApplication(RELOAD_REASONS.OFFLINE_RETRY)}
        />
        <p className={'error__copyright'}>{safeHTML(t(copyright, copyrightParams))}</p>
      </div>
    </section>
  )
})
export default Error
